import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

import { SubNav } from "./subnav";
import { DevopsDropdown } from "./subnav-devops-dropdown";

export const SubNavSoftwareDevelopment = () => {
    const intl = useIntl();
    const productKey = "agile";

    const headerLinkText = intl.formatMessage({
        id: "software-development.logo-label",
        defaultMessage: "Software Development"
    });

    return (
        <SubNav
            productKey={productKey}
            headerLinkText={headerLinkText}
            headerLinkHref={useLocalizedHref("/software-development")}
            desktopLinks={[
                {
                    globalLinksKey: "devops",
                    linkText: intl.formatMessage({
                        id: "software-development.subnav.devops",
                        defaultMessage: "DevOps"
                    }),
                    hasSubnav: true,
                    content: <DevopsDropdown />
                },
                {
                    globalLinksKey: "agile",
                    linkText: intl.formatMessage({
                        id: "software-development.subnav.agile",
                        defaultMessage: "Agile"
                    }),
                    href: useLocalizedHref("/agile"),
                    hasSubnav: false
                },
                {
                    globalLinksKey: "microservices",
                    linkText: intl.formatMessage({
                        id: "software-development.subnav.microservices",
                        defaultMessage: "Microservices"
                    }),
                    href: useLocalizedHref("/microservices"),
                    hasSubnav: false
                }
            ]}
            mobileLinks={[
                {
                    mobileLinkKey: "subnav-links",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "devops",
                            linkText: intl.formatMessage({
                                id: "software-development.subnav-mobile.dropdown.devops",
                                defaultMessage: "DevOps"
                            }),
                            hasSubnav: true,
                            dropdownType: "devops"
                        },
                        {
                            globalLinksKey: "agile",
                            linkText: intl.formatMessage({
                                id: "software-development.subnav-mobile.agile",
                                defaultMessage: "Agile"
                            }),
                            hasSubnav: false,
                            href: useLocalizedHref("/agile")
                        },
                        {
                            globalLinksKey: "microservices",
                            linkText: intl.formatMessage({
                                id: "software-development.subnav-mobile.microservices",
                                defaultMessage: "Microservices"
                            }),
                            hasSubnav: false,
                            href: useLocalizedHref("/microservices")
                        }
                    ]
                }
            ]}
        />
    );
};
